export const auth = {
  login: {
    title: 'Connexion',
    subtitle: 'Accédez à votre compte Travail Global',
    candidate: 'Candidat',
    employer: 'Recruteur',
    email: 'Adresse email',
    password: 'Mot de passe',
    remember: 'Se souvenir de moi',
    forgot: 'Mot de passe oublié ?',
    submit: 'Se connecter',
    loading: 'Connexion...',
    error: 'Identifiants invalides ou erreur serveur.',
    noAccount: 'Vous n\'avez pas de compte ?',
    register: 'Inscrivez-vous',
    welcomeTitle: 'Bienvenue sur Travail Global',
    welcomeSubtitle: 'Trouvez les meilleures opportunités de carrière partout dans le monde.'
  },
  register: {
    candidateTitle: 'Inscription Candidat',
    candidateSubtitle: 'Trouvez les meilleures opportunités',
    firstName: 'Prénom',
    lastName: 'Nom',
    email: 'Email',
    phone: 'Téléphone',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    terms: 'J\'accepte les',
    termsLink: 'conditions d\'utilisation',
    submit: 'S\'inscrire',
    loading: 'Inscription...',
    hasAccount: 'Déjà un compte ?',
    login: 'Connectez-vous',
    welcomeTitle: 'Rejoignez notre réseau',
    welcomeSubtitle: 'Créez votre profil et postulez aux meilleures offres.'
  },
  forgotPassword: {
    title: 'Mot de passe oublié',
    subtitle: 'Entrez votre email pour recevoir un lien de réinitialisation',
    email: 'Adresse email',
    submit: 'Envoyer le lien',
    loading: 'Envoi...',
    success: 'Lien envoyé avec succès ! Vérifiez votre boîte mail.',
    backToLogin: 'Retour à la connexion'
  },
  resetPassword: {
    title: 'Réinitialisation',
    subtitle: 'Choisissez votre nouveau mot de passe',
    password: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    submit: 'Réinitialiser',
    loading: 'Réinitialisation...',
    success: 'Mot de passe réinitialisé avec succès !',
    error: 'Token invalide ou expiré.'
  }
};
